/**
 * File: category_articles_list_text_item.tsx
 * Description: Renders the standard title + last-updated-date text block used inside a CategoryArticlesList item.
 */

import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

/**
 * Props for the CategoryArticlesListTextItem component.
 *
 * @property {string} title - The article's title, rendered as the primary text.
 * @property {string} creationDate - ISO 8601 date string (Article.creation_date) rendered as the secondary text.
 */
interface CategoryArticlesListTextItemProps {
  title: string;
  creationDate: string;
}

/**
 * Renders the primary/secondary text block for an article: its title and its
 * last-updated date, formatted for es-ES.
 *
 * @param {string} props.title - The article's title.
 * @param {string} props.creationDate - ISO 8601 creation date to format and display.
 * @returns {JSX.Element}
 */
function CategoryArticlesListTextItem({ title, creationDate }: CategoryArticlesListTextItemProps) {
  return (
    <ListItemText
      primary={
        <Typography variant="body1">
          {title}
        </Typography>
      }
      secondary={
        <Typography variant="subtitle2">
          Última Actualización: {new Date(creationDate).toLocaleDateString('es-ES')}
        </Typography>
      }
    />
  );
}

export default CategoryArticlesListTextItem;
